module.exports = __webpack_public_path__ + "ua.1c23b8c9.svg";